module.exports = __webpack_public_path__ + "img/joy_left_bottom.7f09ebc6.png";